import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-show-redemption-info-dialog',
  templateUrl: './show-redemption-info-dialog.component.html',
  styleUrls: ['./show-redemption-info-dialog.component.scss'],
})
export class ShowRedemptionInfoDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string | null) {}

  ngOnInit() {}
}
